module.exports = __webpack_public_path__ + "static/media/close-line-blank.d0751e4d.png";